import styled from 'styled-components';
import Collapse from '../Collapse/Collapse';

export const VariableDetectorCollapse = styled(Collapse)`
  margin-bottom: 16px;
`;
